export const PACKED_ITEMS_SKU_FILTER_MIN_QUERY_LENGTH = 2
export const PACKED_ITEMS_SKU_FILTER_MAX_RESULTS = 200

export type PackedItemSkuFilterSearchResult = {
  items: string[]
  truncated: boolean
}

export function filterPackedItemSkuOptions(
  allSkus: string[],
  query: string,
  configuration?: {
    minQueryLength?: number
    maxResults?: number
  }
): PackedItemSkuFilterSearchResult {
  const minQueryLength =
    configuration?.minQueryLength ?? PACKED_ITEMS_SKU_FILTER_MIN_QUERY_LENGTH
  const maxResults =
    configuration?.maxResults ?? PACKED_ITEMS_SKU_FILTER_MAX_RESULTS

  const normalizedQuery = query.trim().toLowerCase()
  if (normalizedQuery.length < minQueryLength) {
    return { items: [], truncated: false }
  }

  const matches: string[] = []
  for (const sku of allSkus) {
    if (sku.toLowerCase().includes(normalizedQuery)) {
      matches.push(sku)
      if (matches.length > maxResults) {
        return { items: matches.slice(0, maxResults), truncated: true }
      }
    }
  }

  return { items: matches, truncated: false }
}

export function buildPackedItemSkuComboboxItems(
  searchResult: PackedItemSkuFilterSearchResult,
  selectedSku: string | null,
  typedQuery?: string
): string[] {
  const items = [...searchResult.items]
  const trimmedQuery = typedQuery?.trim() ?? ''
  if (
    trimmedQuery.length >= PACKED_ITEMS_SKU_FILTER_MIN_QUERY_LENGTH &&
    !items.includes(trimmedQuery)
  ) {
    items.unshift(trimmedQuery)
  }
  if (selectedSku != null && selectedSku !== '' && !items.includes(selectedSku)) {
    items.unshift(selectedSku)
  }
  return items
}
